import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import { showCustomImage, showCustomImageMobile } from 'globalCommon/utils/index';
import { UserLogoMap, UserLogoMapMobileAll } from '../common/utils/imageSource';
import './reset.css';
import './style.css';

const init = () => {
    // M 端所有站点都用滚动 logo 列表（不是按 SYSTEM 分支），两个容器都渲染，靠 CSS 断点切换显示
    showCustomImage(UserLogoMap, 'show-logo');
    showCustomImageMobile(UserLogoMapMobileAll, 'show-logo-mobile');
    commonPageService({ renderAfter: syncRender, isMobile: 'auto' });
};

init();
